import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Notification } from "@common/models/approval-flow";
import { environment } from "environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class NotificationService{

  constructor(private _http: HttpClient) {}

  /**
   * Función para crear una notificación
   * @param notification 
   * @returns 
   */
  createNotification(notification:Notification[]){
    return this._http.post<Notification>(`${environment.bpmApiUrl}/api/notification`, notification).pipe(
        map((response: any) => response as Notification),
        catchError(e => {
          return throwError(e);
        })
      );
  }

  /**
   * Funcion para validar que el usuario tenga permiso de realizar un cambio de estado
   * @param objectId id del objeto
   * @param userId id del usuario
   * @param newStatusCode código del estado nuevo
   * @returns 
   */
  getByObjectIdAndUsersIdAndNewStatusCode(objectId:any,userId:number,newStatusCode:string){
    return this._http.get<Boolean>
    (`${environment.bpmApiUrl}/api/notification/${objectId}/${userId}/${newStatusCode}`);
  }

  /**
   * Obtiene un listado de notificaciones por menu id y objeto id
   * @param {any} objectId Indica el id del objeto
   * @param {number} menuId Indica el id del menú
   * @returns {Observable<Notification[]>} Devuelve un observable de notificaciones
   */
  getByObjectIdAndMenuId(objectId:any,menuId:number): Observable<Notification[]>{
    return this._http.get<Notification[]>(`${environment.bpmApiUrl}/api/notification/${objectId}/${menuId}`).pipe(
      map((response: any) => response as Notification[]),
      catchError(e => {
        return throwError(e);
      })
    );
  }

}
